// extracted by mini-css-extract-plugin
export var formContainer = "MobileEmbed-module--formContainer--03f43";
export var formElements = "MobileEmbed-module--formElements--f6ba9";
export var formSection = "MobileEmbed-module--formSection--95327";
export var formWrapper = "MobileEmbed-module--formWrapper--16e7a";
export var heading = "MobileEmbed-module--heading--1bc06";
export var imageBanner = "MobileEmbed-module--imageBanner--c12b7";
export var inputContainer = "MobileEmbed-module--inputContainer--d80b6";
export var split = "MobileEmbed-module--split--8f531";
export var submitButton = "MobileEmbed-module--submitButton--a31ad";
export var subtitle = "MobileEmbed-module--subtitle--89eb3";